import { ErrorPacket, Next, Pipe } from '../types';
import { ErrorConverterService } from '../../services/error-converter.service';
import { IJsonApiErrorDocument } from '../../services/jsonapi-error.interface';

export class EmailNotValidatedPipe implements Pipe<ErrorPacket, ErrorPacket> {
    public constructor(private readonly errorConverter: ErrorConverterService) {}

    public handle(packet: ErrorPacket, next: Next<ErrorPacket, ErrorPacket>): ErrorPacket {
        if (packet.result) return next(packet);

        const error: IJsonApiErrorDocument = packet.data as IJsonApiErrorDocument;

        if (error?.errors?.[0]?.title !== 'El correo no ha sido validado') {
            return next(packet);
        }

        console.warn('User not validate!', error);

        return {
            ...packet,
            result: this.errorConverter.getAppErrorFromJsonApi(error),
        };
    }
}
